(() => { const SELECTOR = '[data-wi-product]'; const initialized = new
WeakSet();

const getI18n = () => { const node =
document.querySelector('[data-wi-i18n]'); if (!node) return {};

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[WI Product] Unable to parse translations.', error);
      return {};
    }

};

const formatTemplate = (template = '', values = {}) =>
Object.entries(values).reduce( (output, [key, value]) =>
output.split(`__${key}__`).join(String(value)), template );

const initProduct = (root) => { if (!root || initialized.has(root))
return; initialized.add(root);

    const configNode = root.querySelector('[data-wi-product-config]');
    let config = {};

    try {
      config = JSON.parse(configNode?.textContent || '{}');
    } catch (error) {
      console.warn('WI Product: invalid product configuration.', error);
    }

    const VARIANT_STATE_SECTION = 'wi-variant-state';
    const variantStateCache = new Map();
    const productI18n = getI18n().product || {};
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const form = root.querySelector('[data-wi-product-form]');
    const variantInput = root.querySelector('[data-wi-variant-input]');
    const addButton = root.querySelector('[data-wi-add]');
    const addLabel = root.querySelector('[data-wi-add-label]');
    const addPrice = root.querySelector('[data-wi-add-price]');
    const dynamicCheckout = root.querySelector('[data-wi-dynamic-checkout]');
    const formMessage = root.querySelector('[data-wi-form-message]');
    const quantityInput = root.querySelector('[data-wi-quantity]');
    const mobilePrice = root.querySelector('[data-wi-mobile-price]');

    const optionGroups = Array.from(root.querySelectorAll('[data-wi-option-group]'));
    const optionChoices = Array.from(root.querySelectorAll('[data-wi-option-value]'));

    const priceNode = root.querySelector('[data-wi-price]');
    const compareNode = root.querySelector('[data-wi-compare-price]');
    const discountNode = root.querySelector('[data-wi-discount]');
    const unitPriceNode = root.querySelector('[data-wi-unit-price]');

    const mediaItems = Array.from(root.querySelectorAll('[data-wi-product-media]'));
    const thumbnails = Array.from(root.querySelectorAll('[data-wi-thumbnail]'));
    const progress = Array.from(root.querySelectorAll('[data-wi-progress]'));
    const stage = root.querySelector('[data-wi-media-stage]');
    const thumbTrack = root.querySelector('[data-wi-thumb-track]');

    const prevButton = root.querySelector('[data-wi-gallery-prev]');
    const nextButton = root.querySelector('[data-wi-gallery-next]');
    const thumbPrev = root.querySelector('[data-wi-thumb-prev]');
    const thumbNext = root.querySelector('[data-wi-thumb-next]');

    const stickyNav = root.querySelector('[data-wi-sticky-nav]');
    const stickyIndicator = root.querySelector('[data-wi-sticky-indicator]');
    const navButtons = Array.from(root.querySelectorAll('[data-wi-product-nav-target]'));
    const submitMirrors = Array.from(root.querySelectorAll('[data-wi-submit-form]'));
    const reviewJump = root.querySelector('[data-wi-review-jump]');
    const mobileBar = root.querySelector('[data-wi-mobile-bar]');

    let currentVariant = config.selectedVariant || null;
    // The variant whose image the gallery is currently showing. Usually equals
    // currentVariant, but is set instantly on click (before the server responds).
    let mediaVariant = currentVariant;
    let mediaPreviewed = false;
    const variantMediaMap = config.variantMedia || {};
    const variantStateRequests = new Map();

    let variantRequestController = null;
    let activeMediaIndex = Math.max(
      0,
      thumbnails.findIndex((thumb) => thumb.classList.contains('is-active'))
    );
    let pointerStartX = null;
    let pointerStartY = null;
    let scrollFrame = null;

    const getStickyHeaderHeight = () => {
      const header = document.querySelector('.wi-header--sticky') || document.querySelector('.shopify-section-header-sticky');
      if (!header) return 0;

      const style = getComputedStyle(header);
      if (style.position !== 'sticky' && style.position !== 'fixed') return 0;

      return Math.max(0, Math.round(header.getBoundingClientRect().height));
    };

    const syncStickyTop = () => {
      root.style.setProperty('--wi-product-sticky-top', `${getStickyHeaderHeight()}px`);
    };

    const setFormMessage = (message = '', isError = false) => {
      if (!formMessage) return;
      formMessage.textContent = message;
      formMessage.classList.toggle('is-error', isError);
    };

    const canPurchaseVariant = (variant = currentVariant) => {
      // Inventory status is the final authority; a sold-out option can be
      // selected to inspect its price, but must never become purchasable.
      if (!variant || variant.available === false) return false;

      if (variant.requiresSellingPlan && config.nativeSellingPlansEnabled === false) {
        return false;
      }

      if (typeof variant.purchaseAvailable === 'boolean') {
        return Boolean(variant.available && variant.purchaseAvailable);
      }
      return Boolean(variant.available);
    };

    const syncDynamicCheckoutState = (purchasable = canPurchaseVariant()) => {
      if (!dynamicCheckout) return;
      // Shopify may insert a payment web component after page load.
      // Inert prevents pointer, keyboard and focus interaction in both cases.
      dynamicCheckout.inert = !purchasable;
      dynamicCheckout.toggleAttribute('inert', !purchasable);
      dynamicCheckout.setAttribute('aria-disabled', purchasable ? 'false' : 'true');
    };

    const setAddState = (state) => {
      if (!addButton) return;

      addButton.classList.toggle('is-loading', state === 'loading');

      if (state === 'loading') {
        addButton.disabled = true;
        return;
      }

      addButton.disabled = !canPurchaseVariant();
    };

    // Variant media is matched by Shopify media ID.
    // data-variant-media="true" is set in Liquid on any media assigned to a variant.
    const getMediaId = (element) => String(element?.dataset?.mediaId || '');

    const isVariantMedia = (element) => element?.dataset?.variantMedia === 'true';

    const getSelectedVariantMediaId = (variant = mediaVariant) => {
      const id = String(variant?.featuredMediaId || '');
      return id && id !== '0' ? id : '';
    };

    const isElementAllowedForVariant = (
      element,
      selectedMediaId = getSelectedVariantMediaId()
    ) => {
      if (!element) return false;

      // Shared media (not assigned to any variant) is always visible.
      if (!isVariantMedia(element)) return true;

      // Variant media is visible only for the currently selected variant.
      return Boolean(selectedMediaId) && getMediaId(element) === selectedMediaId;
    };

    const getVisibleMediaIndexes = (
      selectedMediaId = getSelectedVariantMediaId()
    ) =>
      mediaItems
        .map((item, index) =>
          isElementAllowedForVariant(item, selectedMediaId) ? index : -1
        )
        .filter((index) => index >= 0);

    const syncVariantMediaVisibility = (variant = mediaVariant) => {
      const selectedMediaId = getSelectedVariantMediaId(variant);

      mediaItems.forEach((item) => {
        if (!isElementAllowedForVariant(item, selectedMediaId)) {
          item.hidden = true;
          item.classList.remove('is-active');
        }
      });

      thumbnails.forEach((thumb) => {
        const allowed = isElementAllowedForVariant(thumb, selectedMediaId);
        thumb.hidden = !allowed;

        if (!allowed) {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-current', 'false');
        }
      });

      progress.forEach((item) => {
        const allowed = isElementAllowedForVariant(item, selectedMediaId);
        item.hidden = !allowed;
        if (!allowed) item.classList.remove('is-active');
      });

      const visibleIndexes = getVisibleMediaIndexes(selectedMediaId);

      const visibleThumbnailCount = thumbnails.filter(
        (thumb) => !thumb.hidden
      ).length;

      const hasMultipleVisibleMedia = visibleIndexes.length > 1;
      const hasMultipleVisibleThumbnails = visibleThumbnailCount > 1;

      if (prevButton) prevButton.hidden = !hasMultipleVisibleMedia;
      if (nextButton) nextButton.hidden = !hasMultipleVisibleMedia;
      if (thumbPrev) thumbPrev.hidden = !hasMultipleVisibleThumbnails;
      if (thumbNext) thumbNext.hidden = !hasMultipleVisibleThumbnails;

      if (!visibleIndexes.includes(activeMediaIndex)) {
        activeMediaIndex = visibleIndexes[0] ?? 0;
      }

      return visibleIndexes;
    };

    const pauseInactiveVideos = () => {
      mediaItems.forEach((item, index) => {
        const video = item.querySelector('video');
        if (!video) return;

        if (index !== activeMediaIndex) {
          video.pause();
        }
      });
    };

    const warmMedia = (item) => {
      if (!item || item.dataset.wiWarmed) return;
      item.dataset.wiWarmed = 'true';
      const img = item.querySelector('img');
      if (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().catch(() => {});
      }
    };

    const warmAdjacentMedia = () => {
      const visibleIndexes = getVisibleMediaIndexes();
      if (visibleIndexes.length < 2) return;

      const activeVisibleIndex = Math.max(0, visibleIndexes.indexOf(activeMediaIndex));
      const nextIndex = visibleIndexes[(activeVisibleIndex + 1) % visibleIndexes.length];
      const prevIndex =
        visibleIndexes[(activeVisibleIndex - 1 + visibleIndexes.length) % visibleIndexes.length];

      warmMedia(mediaItems[nextIndex]);
      warmMedia(mediaItems[prevIndex]);
    };

    const activateMedia = (index, scrollThumb = true) => {
      const visibleIndexes = getVisibleMediaIndexes();
      if (!visibleIndexes.length) return;

      if (!visibleIndexes.includes(index)) {
        index = visibleIndexes[0];
      }

      activeMediaIndex = index;

      mediaItems.forEach((item, itemIndex) => {
        const allowed = visibleIndexes.includes(itemIndex);
        const active = allowed && itemIndex === activeMediaIndex;

        item.hidden = !active;
        item.classList.toggle('is-active', active);

        if (active) warmMedia(item);
      });

      const activeMediaId = getMediaId(mediaItems[activeMediaIndex]);
      const selectedMediaId = getSelectedVariantMediaId();

      thumbnails.forEach((thumb) => {
        const allowed = isElementAllowedForVariant(thumb, selectedMediaId);
        const active = allowed && Boolean(activeMediaId) && getMediaId(thumb) === activeMediaId;

        thumb.hidden = !allowed;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      progress.forEach((item) => {
        const allowed = isElementAllowedForVariant(item, selectedMediaId);
        const active = allowed && Boolean(activeMediaId) && getMediaId(item) === activeMediaId;

        item.hidden = !allowed;
        item.classList.toggle('is-active', active);
      });

      pauseInactiveVideos();
      warmAdjacentMedia();

      if (scrollThumb) {
        const activeThumb = thumbnails.find((thumb) => getMediaId(thumb) === activeMediaId);

        if (activeThumb && thumbTrack && !activeThumb.hidden) {
          const trackRect = thumbTrack.getBoundingClientRect();
          const thumbRect = activeThumb.getBoundingClientRect();

          if (thumbRect.left < trackRect.left || thumbRect.right > trackRect.right) {
            thumbTrack.scrollBy({
              left: thumbRect.left - trackRect.left - (trackRect.width - thumbRect.width) / 2,
              behavior: reducedMotion ? 'auto' : 'smooth'
            });
          }
        }
      }
    };

    const activateSelectedVariantMedia = (variant = mediaVariant) => {
      const selectedMediaId = getSelectedVariantMediaId(variant);
      if (!selectedMediaId) return false;

      const index = mediaItems.findIndex((item) => getMediaId(item) === selectedMediaId);
      if (index < 0) return false;

      activateMedia(index);
      return true;
    };

    // Shows the given variant's image and hides every other variant image.
    const applyVariantMedia = (variant) => {
      mediaVariant = variant;
      syncVariantMediaVisibility(variant);

      if (!activateSelectedVariantMedia(variant)) {
        activateMedia(activeMediaIndex, false);
      }
    };

    const findMediaItem = (mediaId) =>
      mediaItems.find((item) => getMediaId(item) === String(mediaId));

    const getChoiceMediaId = (choice) => {
      const variantId = choice?.dataset.variantId;
      if (!variantId || !(variantId in variantMediaMap)) return null;
      return String(variantMediaMap[variantId] || 0);
    };

    // Swap the gallery image the moment a size is clicked. The image map is
    // already on the page, so there is no need to wait for the server.
    const previewChoiceMedia = (choice) => {
      const mediaId = getChoiceMediaId(choice);
      if (mediaId == null) return;

      applyVariantMedia({ featuredMediaId: mediaId });
      mediaPreviewed = true;
    };

    const warmThumbnail = (mediaId) => {
      const thumbImg = thumbnails
        .find((thumb) => getMediaId(thumb) === String(mediaId))
        ?.querySelector('img');
      if (thumbImg) thumbImg.loading = 'eager';
    };

    // Download variant images ahead of time so the swap is instant.
    // Runs once, on the shopper's first interaction with the size picker,
    // so visitors who never touch the picker don't pay the bandwidth.
    let variantImagesWarmed = false;
    const warmAllVariantMedia = () => {
      if (variantImagesWarmed) return;
      variantImagesWarmed = true;

      Object.values(variantMediaMap).forEach((mediaId) => {
        if (!mediaId) return;
        warmMedia(findMediaItem(mediaId));
        warmThumbnail(mediaId);
      });
    };

    const moveMedia = (direction) => {
      const visibleIndexes = getVisibleMediaIndexes();
      if (visibleIndexes.length < 2) return;

      let position = visibleIndexes.indexOf(activeMediaIndex);
      if (position < 0) position = 0;

      const nextPosition =
        (position + direction + visibleIndexes.length) % visibleIndexes.length;

      activateMedia(visibleIndexes[nextPosition]);
    };

    prevButton?.addEventListener('click', () => moveMedia(-1));
    nextButton?.addEventListener('click', () => moveMedia(1));

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.hidden) return;

        const mediaId = String(thumb.dataset.mediaId || '');
        const index = mediaItems.findIndex(
          (item) => String(item.dataset.mediaId || '') === mediaId
        );

        if (index >= 0) activateMedia(index, false);
      });
    });

    thumbPrev?.addEventListener('click', () => {
      thumbTrack?.scrollBy({
        left: -260,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    });

    thumbNext?.addEventListener('click', () => {
      thumbTrack?.scrollBy({
        left: 260,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    });

    stage?.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      },
      { passive: true }
    );

    stage?.addEventListener(
      'pointerup',
      (event) => {
        if (pointerStartX == null || pointerStartY == null) return;

        const dx = event.clientX - pointerStartX;
        const dy = event.clientY - pointerStartY;
        pointerStartX = null;
        pointerStartY = null;

        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
        moveMedia(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    stage?.addEventListener('pointercancel', () => {
      pointerStartX = null;
      pointerStartY = null;
    }, { passive: true });

    const idleWarm = window.requestIdleCallback || ((cb) => setTimeout(cb, 400));
    idleWarm(warmAdjacentMedia);

    stage?.addEventListener('pointerenter', warmAdjacentMedia, { once: true, passive: true });
    stage?.addEventListener('touchstart', warmAdjacentMedia, { once: true, passive: true });

    const getSelectedOptionValueIds = () =>
      optionGroups
        .map((group) =>
          group.querySelector('[data-wi-option-value][aria-pressed="true"]')?.dataset
            .optionValueId || ''
        )
        .filter(Boolean);

    const getSelectionSnapshot = () =>
      optionGroups.map(
        (group) =>
          group.querySelector('[data-wi-option-value][aria-pressed="true"]')?.dataset
            .optionValueId || ''
      );

    const syncSelectedOptionLabels = () => {
      optionGroups.forEach((group) => {
        const selected = group.querySelector('[data-wi-option-value][aria-pressed="true"]');
        const selectedLabel = group.querySelector('[data-wi-selected-option]');

        if (selectedLabel) {
          selectedLabel.textContent = selected?.dataset.optionValue || '';
        }
      });
    };

    const restoreSelection = (snapshot = []) => {
      optionGroups.forEach((group, index) => {
        const selectedId = snapshot[index] || '';

        group.querySelectorAll('[data-wi-option-value]').forEach((choice) => {
          const active = choice.dataset.optionValueId === selectedId;
          choice.classList.toggle('is-active', active);
          choice.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });

      syncSelectedOptionLabels();
    };

    const markSelectedChoice = (choice) => {
      const group = choice.closest('[data-wi-option-group]');
      if (!group) return;

      group.querySelectorAll('[data-wi-option-value]').forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      syncSelectedOptionLabels();
    };

    const updateOptionAvailability = () => {
      optionChoices.forEach((choice) => {
        const available = choice.dataset.optionAvailable !== 'false';
        const hasVariant = Boolean(choice.dataset.variantId);
        const currentUrl = root.dataset.productUrl || config.productUrl || window.location.pathname;
        const destinationUrl = choice.dataset.productUrl || currentUrl;
        const linkedProduct = new URL(destinationUrl, window.location.origin).pathname !==
          new URL(currentUrl, window.location.origin).pathname;

        // Sold out does not mean non-selectable. Only a nonexistent option
        // combination (without a variant or linked product) stays disabled.
        const selectable = hasVariant || linkedProduct;
        choice.disabled = !selectable;
        choice.setAttribute('aria-disabled', selectable ? 'false' : 'true');
        choice.classList.toggle('is-sold-out', selectable && !available);
      });
    };

    const applyOptionStates = (doc) => {
      const states = Array.from(doc.querySelectorAll('[data-wi-option-state]'));
      const byId = new Map();
      const byValue = new Map();

      states.forEach((state) => {
        if (state.dataset.optionValueId) {
          byId.set(state.dataset.optionValueId, state);
        }

        byValue.set(
          `${state.dataset.optionPosition || ''}::${state.dataset.optionValue || ''}`,
          state
        );
      });

      optionChoices.forEach((choice) => {
        const fallbackKey = `${choice.dataset.optionPosition || ''}::${choice.dataset.optionValue || ''}`;
        const state = byId.get(choice.dataset.optionValueId) || byValue.get(fallbackKey);
        if (!state) return;

        choice.dataset.optionValueId = state.dataset.optionValueId || choice.dataset.optionValueId;
        choice.dataset.productUrl = state.dataset.productUrl || choice.dataset.productUrl;
        choice.dataset.optionAvailable = state.dataset.available || 'false';
        choice.dataset.variantId = state.dataset.variantId || '';
        choice.dataset.variantPrice = state.dataset.variantPrice || '';

        const selected = state.dataset.selected === 'true';
        choice.classList.toggle('is-active', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      updateOptionAvailability();
      syncSelectedOptionLabels();
    };

    const readVariantState = (doc) => {
      const script = doc.querySelector('[data-wi-variant-state-json]');
      if (!script) throw new Error('Variant state is missing from the response.');

      const payload = JSON.parse(script.textContent || '{}');
      return payload && typeof payload === 'object' ? payload : {};
    };

    const rememberVariantState = (key, html) => {
      variantStateCache.set(key, html);

      if (variantStateCache.size > 24) {
        variantStateCache.delete(variantStateCache.keys().next().value);
      }
    };

    const clearDynamicBadges = () => {
      root.querySelectorAll('[data-wi-dynamic-badge]').forEach((badge) => badge.remove());

      optionChoices.forEach((choice) => {
        choice.classList.remove('has-pack-badge', 'has-pack-badge--super', 'has-pack-badge--popular');
      });
    };

    const groupLooksCommercial = (group) => {
      if (!group) return false;

      if (group.classList.contains('is-pack')) return true;
      if (group.classList.contains('is-color') || group.classList.contains('is-size')) return false;

      const labels = Array.from(group.querySelectorAll('[data-wi-option-value]'))
        .map((choice) => choice.dataset.optionValue || '')
        .join(' ');

      return /\b(pack|packs|pair|pairs|combo|offer|bundle|bundles|set|sets|piece|pieces|pcs|quantity|qty)\b/i.test(labels);
    };

    const getPricedChoicesForGroup = (group) =>
      Array.from(group.querySelectorAll('[data-wi-option-value]'))
        // Keep promotional badges based on variants that can be purchased.
        .filter((choice) => !choice.disabled && choice.dataset.optionAvailable !== 'false' && choice.dataset.variantPrice !== '')
        .map((choice, index) => ({
          choice,
          index,
          price: Number(choice.dataset.variantPrice || 0)
        }))
        .filter((item) => Number.isFinite(item.price))
        .sort((a, b) => a.price - b.price || a.index - b.index);

    const addBadge = (choice, label, type) => {
      if (!choice || !label) return;

      const badge = document.createElement('span');
      badge.className = `wi-product__variant-badge wi-product__variant-badge--${type}`;
      badge.dataset.wiDynamicBadge = type;
      badge.textContent = label;
      badge.setAttribute('aria-hidden', 'true');
      choice.appendChild(badge);
      choice.classList.add('has-pack-badge', `has-pack-badge--${type}`);
    };

    const updateDynamicBadges = () => {
      clearDynamicBadges();

      if (!config.packBadges?.enabled || optionGroups.length === 0) return;

      const group =
        optionGroups.find((item) => item.classList.contains('is-pack')) ||
        optionGroups.find(groupLooksCommercial) ||
        (optionGroups.length === 1 && !optionGroups[0].classList.contains('is-color') && !optionGroups[0].classList.contains('is-size')
          ? optionGroups[0]
          : null);

      if (!group) return;

      const priced = getPricedChoicesForGroup(group);
      if (priced.length < 2) return;

      const highest = priced[priced.length - 1];
      const popular = priced.length >= 3 ? priced[1] : priced[0];

      addBadge(highest.choice, config.packBadges.superSaver || '', 'super');

      if (popular && popular.choice !== highest.choice) {
        addBadge(popular.choice, config.packBadges.mostBought || '', 'popular');
      }
    };

    const syncDisplayedPrice = ({
      price = 0,
      priceText = '',
      compareAtPrice = 0,
      compareText = '',
      unitPriceText = ''
    } = {}) => {
      if (priceNode) {
        const priceTemplate = document.createElement('template');
        priceTemplate.innerHTML = priceText || '';
        priceNode.replaceChildren(priceTemplate.content.cloneNode(true));
      }

      const numericPrice = Number(price || 0);
      const numericCompare = Number(compareAtPrice || 0);
      const hasCompare = numericCompare > numericPrice;

      if (compareNode) {
        compareNode.hidden = !hasCompare;

        if (hasCompare && compareText) {
          const compareTemplate = document.createElement('template');
          compareTemplate.innerHTML = compareText;
          compareNode.replaceChildren(compareTemplate.content.cloneNode(true));
        } else {
          compareNode.replaceChildren();
        }
      }

      if (discountNode) {
        discountNode.hidden = !hasCompare;

        if (hasCompare && numericCompare > 0) {
          const percentage = Math.round(
            ((numericCompare - numericPrice) * 100) / numericCompare
          );

          discountNode.textContent = formatTemplate(productI18n.savePercent || 'SAVE __PERCENT__%', { PERCENT: percentage });
        } else {
          discountNode.textContent = '';
        }
      }

      if (unitPriceNode) {
        unitPriceNode.hidden = !unitPriceText;
        unitPriceNode.textContent = unitPriceText || '';
      }

      if (mobilePrice) {
        const mobilePriceTemplate = document.createElement('template');
        mobilePriceTemplate.innerHTML = priceText || '';
        mobilePrice.replaceChildren(mobilePriceTemplate.content.cloneNode(true));
      }

      if (addPrice) {
        if (canPurchaseVariant() && priceText) {
          const addPriceTemplate = document.createElement('template');
          addPriceTemplate.innerHTML = ` · ${priceText}`;
          addPrice.replaceChildren(addPriceTemplate.content.cloneNode(true));
        } else {
          addPrice.textContent = '';
        }
      }
    };

    const getSellingPlanHost = () => root.querySelector('[data-wi-selling-plans-host]');
    const getSellingPlanInput = () => root.querySelector('[data-wi-selling-plan-input]');
    const getSelectedPurchaseOption = () =>
      root.querySelector('[data-wi-purchase-option]:checked');

    const syncSellingPlanSelectionClasses = () => {
      root.querySelectorAll('.wi-product__selling-plan-option').forEach((label) => {
        const input = label.querySelector('[data-wi-purchase-option]');
        label.classList.toggle('is-selected', Boolean(input?.checked));
      });
    };

    const syncPurchaseOption = (updateUrl = true) => {
      const option = getSelectedPurchaseOption();
      const sellingPlanInput = getSellingPlanInput();

      syncSellingPlanSelectionClasses();

      if (!option) {
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
          sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const sellingPlanId = option.dataset.sellingPlanId || '';

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncDisplayedPrice({
        price: Number(option.dataset.price || currentVariant?.price || 0),
        priceText: option.dataset.priceText || currentVariant?.priceText || '',
        compareAtPrice: Number(option.dataset.compareAtPrice || 0),
        compareText: option.dataset.compareText || '',
        unitPriceText: option.dataset.unitPriceText || ''
      });

      if (updateUrl && history.replaceState) {
        const url = new URL(window.location.href);

        if (sellingPlanId) url.searchParams.set('selling_plan', sellingPlanId);
        else url.searchParams.delete('selling_plan');

        history.replaceState({}, '', url);
      }
    };

    const replaceSellingPlans = (doc, preferredSellingPlanId = '') => {
      const host = getSellingPlanHost();
      if (!host) return;

      const template = doc.querySelector('[data-wi-selling-plans-template]');
      host.innerHTML = template?.innerHTML || '';

      const heading = host.dataset.heading || '';
      const legend = host.querySelector('.wi-product__selling-plans-heading');
      if (legend && heading) legend.textContent = heading;

      if (preferredSellingPlanId) {
        const preferred = Array.from(host.querySelectorAll('[data-wi-purchase-option]')).find(
          (input) => input.dataset.sellingPlanId === preferredSellingPlanId && !input.disabled
        );

        if (preferred) {
          host.querySelectorAll('[data-wi-purchase-option]').forEach((input) => {
            input.checked = input === preferred;
          });
        }
      }

      syncSellingPlanSelectionClasses();
    };

    const syncVariantUI = (variant, updateUrl = true) => {
      if (!variant) return;

      currentVariant = variant;
      const purchasable = canPurchaseVariant(variant);

      if (variantInput) {
        variantInput.value = String(variant.id);
        variantInput.disabled = !purchasable;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncSelectedOptionLabels();

      syncDisplayedPrice({
        price: variant.price,
        priceText: variant.priceText || '',
        compareAtPrice: variant.compareAtPrice || 0,
        compareText: variant.compareText || '',
        unitPriceText: variant.unitPriceText || ''
      });

      if (addLabel) {
        addLabel.textContent = purchasable
          ? config.addText || productI18n.addToCart || 'Add to cart'
          : config.soldOutText || productI18n.soldOut || 'Sold out';
      }

      if (addButton) addButton.disabled = !purchasable;
      syncDynamicCheckoutState(purchasable);

      submitMirrors.forEach((button) => {
        button.disabled = !purchasable;
        const label = button.querySelector('span');
        if (label) label.textContent = purchasable
          ? config.addText || productI18n.addToCart || 'Add to cart'
          : config.soldOutText || productI18n.soldOut || 'Sold out';
      });

      updateOptionAvailability();
      updateDynamicBadges();

      // If the image was already swapped instantly on click, don't re-activate it
      // (that would undo a thumbnail the shopper clicked while the price loaded).
      const alreadyShown =
        mediaPreviewed &&
        getSelectedVariantMediaId(variant) === getSelectedVariantMediaId(mediaVariant);

      mediaPreviewed = false;

      if (alreadyShown) {
        mediaVariant = variant;
      } else {
        applyVariantMedia(variant);
      }

      setFormMessage('');

      if (updateUrl && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.delete('option_values');
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      if (getSellingPlanHost()) {
        syncPurchaseOption(updateUrl);
      }

      root.dispatchEvent(
        new CustomEvent('wi:variant:change', {
          bubbles: true,
          detail: { variant }
        })
      );
    };

    const getProductUrls = (choice) => {
      const currentProductUrl = root.dataset.productUrl || config.productUrl || window.location.pathname;
      const requestedProductUrl = choice?.dataset.productUrl || currentProductUrl;

      return {
        currentProductUrl,
        currentUrl: new URL(currentProductUrl, window.location.origin),
        requestedUrl: new URL(requestedProductUrl, window.location.origin)
      };
    };

    const buildVariantStateKey = (requestedUrl, selectedIds) => {
      const url = new URL(requestedUrl.toString());
      url.searchParams.set('section_id', VARIANT_STATE_SECTION);
      url.searchParams.set('option_values', selectedIds.join(','));
      return url.toString();
    };

    // One network request per option combination, shared by hover-prefetch and click.
    const loadVariantState = (key) => {
      const cached = variantStateCache.get(key);
      if (cached) return Promise.resolve(cached);

      let pending = variantStateRequests.get(key);

      if (!pending) {
        pending = fetch(key, {
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin'
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Variant update failed (${response.status}).`);
            }
            return response.text();
          })
          .then((html) => {
            rememberVariantState(key, html);
            return html;
          })
          .finally(() => {
            variantStateRequests.delete(key);
          });

        variantStateRequests.set(key, pending);
      }

      return pending;
    };

    const withAbort = (promise, signal) =>
      new Promise((resolve, reject) => {
        const abortError = () => new DOMException('Aborted', 'AbortError');
        if (signal.aborted) {
          reject(abortError());
          return;
        }

        const onAbort = () => reject(abortError());
        signal.addEventListener('abort', onAbort, { once: true });

        promise.then(resolve, reject).finally(() => {
          signal.removeEventListener('abort', onAbort);
        });
      });

    // Hover / focus / touch on a size: fetch its price data and image in advance.
    const prefetchChoice = (choice) => {
      warmAllVariantMedia();

      if (!choice || choice.disabled || choice.getAttribute('aria-pressed') === 'true') return;

      const selectedIds = optionGroups
        .map((group) =>
          group.contains(choice)
            ? choice.dataset.optionValueId || ''
            : group.querySelector('[data-wi-option-value][aria-pressed="true"]')?.dataset
                .optionValueId || ''
        )
        .filter(Boolean);

      if (!selectedIds.length) return;

      const { currentUrl, requestedUrl } = getProductUrls(choice);
      if (requestedUrl.pathname !== currentUrl.pathname) return;

      loadVariantState(buildVariantStateKey(requestedUrl, selectedIds)).catch(() => {});
    };

    const refreshVariantSelection = async (choice) => {
      if (!choice || choice.disabled) return;
      if (choice.getAttribute('aria-pressed') === 'true') return;

      const previousSelection = getSelectionSnapshot();
      const preferredSellingPlanId = getSellingPlanInput()?.value || '';
      markSelectedChoice(choice);

      const selectedIds = getSelectedOptionValueIds();
      if (!selectedIds.length) {
        restoreSelection(previousSelection);
        return;
      }

      const { currentProductUrl, currentUrl, requestedUrl } = getProductUrls(choice);

      if (requestedUrl.pathname !== currentUrl.pathname) {
        requestedUrl.searchParams.set('option_values', selectedIds.join(','));
        window.location.assign(requestedUrl.toString());
        return;
      }

      // Swap the image immediately; price and stock follow from the server.
      previewChoiceMedia(choice);

      const requestKey = buildVariantStateKey(requestedUrl, selectedIds);
      const controller = new AbortController();

      variantRequestController?.abort();
      variantRequestController = controller;
      root.classList.add('is-variant-loading');
      setAddState('loading');
      syncDynamicCheckoutState(false);
      submitMirrors.forEach((button) => {
        button.disabled = true;
      });
      setFormMessage('');

      try {
        const html = await withAbort(loadVariantState(requestKey), controller.signal);

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const payload = readVariantState(doc);

        applyOptionStates(doc);
        replaceSellingPlans(doc, preferredSellingPlanId);
        root.dataset.productUrl = payload.productUrl || currentProductUrl;

        if (!payload.variant) {
          currentVariant = null;
          mediaPreviewed = false;

          if (variantInput) {
            variantInput.value = '';
            variantInput.disabled = true;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (addLabel) addLabel.textContent = config.soldOutText || productI18n.soldOut || 'Sold out';
          if (addPrice) addPrice.textContent = '';
          if (addButton) addButton.disabled = true;
          syncDynamicCheckoutState(false);
          submitMirrors.forEach((button) => {
            button.disabled = true;
            const label = button.querySelector('span');
            if (label) label.textContent = config.soldOutText || productI18n.soldOut || 'Sold out';
          });

          setFormMessage(productI18n.optionUnavailable || 'Option unavailable', true);
          updateDynamicBadges();
          return;
        }

        syncVariantUI(payload.variant);
      } catch (error) {
        if (error?.name === 'AbortError') return;

        console.warn('WI Product: variant update failed.', error);
        restoreSelection(previousSelection);

        // Put the gallery back on the image of the variant that is still selected.
        mediaPreviewed = false;
        if (currentVariant) applyVariantMedia(currentVariant);
        updateOptionAvailability();
        updateDynamicBadges();
        setFormMessage(productI18n.updateOptionError || 'Could not change option', true);
      } finally {
        if (variantRequestController === controller) {
          variantRequestController = null;
          root.classList.remove('is-variant-loading');
          setAddState('idle');
          syncDynamicCheckoutState(canPurchaseVariant());

          submitMirrors.forEach((button) => {
            button.disabled = !canPurchaseVariant();
          });
        }
      }
    };

    root.addEventListener('change', (event) => {
      const purchaseOption = event.target.closest?.('[data-wi-purchase-option]');
      if (!purchaseOption || !root.contains(purchaseOption)) return;

      syncPurchaseOption(true);
    });

    optionChoices.forEach((choice) => {
      choice.addEventListener('click', () => refreshVariantSelection(choice));
      choice.addEventListener('pointerenter', () => prefetchChoice(choice), { passive: true });
      choice.addEventListener('touchstart', () => prefetchChoice(choice), { passive: true });
      choice.addEventListener('focus', () => prefetchChoice(choice));
    });

    root.querySelector('[data-wi-quantity-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
    });

    root.querySelector('[data-wi-quantity-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
    });

    quantityInput?.addEventListener('change', () => {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1)));
    });

    const submitProduct = async () => {
      if (!form || !canPurchaseVariant() || root.classList.contains('is-variant-loading')) return;

      const quantity = Math.max(1, Number(quantityInput?.value || 1));

      setFormMessage('');
      setAddState('loading');

      try {
        const formData = new FormData(form);
        formData.set('sections', 'cart-drawer');
        formData.set('sections_url', `${window.location.pathname}${window.location.search}`);

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: formData
        });

        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || productI18n.addError || 'Could not add product');
        }

        setFormMessage(productI18n.addedToCart || 'Added to cart');

        // Dispatch universal cart events for all theme architectures
        const detail = {
          item: payload,
          quantity,
          sections: payload.sections || null,
          source: 'wi-product'
        };

        root.dispatchEvent(new CustomEvent('wi:cart:updated', { bubbles: true, detail }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
        document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail }));

        if (addLabel) addLabel.textContent = productI18n.added || 'Added';

        window.setTimeout(() => {
          if (addLabel) {
            addLabel.textContent = currentVariant?.available
              ? config.addText || productI18n.addToCart || 'Add to cart'
              : config.soldOutText || productI18n.soldOut || 'Sold out';
          }

          setFormMessage('');
        }, 1400);
      } catch (error) {
        setFormMessage(error?.message || productI18n.addError || 'Could not add to cart', true);
      } finally {
        setAddState('idle');
      }
    };

    if (addButton) {
      addButton.addEventListener('click', (event) => {
        if (addButton.type !== 'submit') {
          event.preventDefault();
          submitProduct();
        }
      });
    }

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      submitProduct();
    });

    submitMirrors.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        submitProduct();
      });
    });

    const getPart = (name) =>
      document.querySelector(`[data-wi-product-part="${name}"]`);

    const refreshNavigationTargets = () => {
      navButtons.forEach((button) => {
        const target = getPart(button.dataset.wiProductNavTarget);
        button.hidden = !target;
      });
    };

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = getPart(button.dataset.wiProductNavTarget);
        if (!target) return;

        const offset = getStickyHeaderHeight() + (stickyNav?.offsetHeight || 0) + 10;

        window.scrollTo({
          top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      });
    });

    refreshNavigationTargets();

    reviewJump?.addEventListener('click', () => {
      const target = getPart('reviews');
      if (!target) return;

      const offset = getStickyHeaderHeight() + (stickyNav?.offsetHeight || 0) + 10;

      window.scrollTo({
        top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    });

    const updateStickyIndicator = (activeButton) => {
      if (!stickyIndicator || !activeButton) return;

      stickyIndicator.style.width = `${activeButton.offsetWidth}px`;
      stickyIndicator.style.transform = `translateX(${activeButton.offsetLeft}px)`;
    };

    const updateScrollState = () => {
      scrollFrame = null;
      syncStickyTop();

      const headerHeight = getStickyHeaderHeight();
      const navHeight = stickyNav?.offsetHeight || 0;
      const marker = headerHeight + navHeight + 24;

      const availableTargets = navButtons
        .filter((button) => !button.hidden)
        .map((button) => ({
          button,
          target: getPart(button.dataset.wiProductNavTarget)
        }))
        .filter((item) => item.target);

      if (stickyNav) {
        const primaryArea = root.querySelector('.wi-product__main');
        const primaryTop = primaryArea?.getBoundingClientRect().top ?? 0;
        const finalTarget = availableTargets[availableTargets.length - 1]?.target || root;
        const finalBottom = finalTarget.getBoundingClientRect().bottom;

        const shouldFix =
          primaryTop <= headerHeight + 1 &&
          finalBottom > headerHeight + Math.max(navHeight, 48) + 12;

        stickyNav.classList.toggle('is-fixed', shouldFix);
      }

      let active = availableTargets[0]?.button || null;

      availableTargets.forEach((item) => {
        if (item.target.getBoundingClientRect().top <= marker) {
          active = item.button;
        }
      });

      navButtons.forEach((button) => {
        button.classList.toggle('is-active', button === active);
      });

      updateStickyIndicator(active);

      if (mobileBar) {
        const purchase = root.querySelector('.wi-product__purchase');
        const purchaseVisible =
          purchase &&
          purchase.getBoundingClientRect().bottom > 0 &&
          purchase.getBoundingClientRect().top < window.innerHeight;

        const rootTop = root.getBoundingClientRect().top;
        const finalTarget = availableTargets[availableTargets.length - 1]?.target || root;
        const stillInProductFlow = finalTarget.getBoundingClientRect().bottom > 0;

        mobileBar.classList.toggle(
          'is-visible',
          !purchaseVisible && rootTop < 0 && stillInProductFlow
        );
      }
    };

    const requestScrollUpdate = () => {
      if (scrollFrame != null) return;
      scrollFrame = requestAnimationFrame(updateScrollState);
    };

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', requestScrollUpdate, { passive: true });

    if (currentVariant) {
      syncVariantUI(currentVariant, false);
    } else {
      updateOptionAvailability();
      updateDynamicBadges();
      syncDynamicCheckoutState(false);
    }

    syncVariantMediaVisibility(mediaVariant);
    activateMedia(activeMediaIndex, false);
    refreshNavigationTargets();
    requestScrollUpdate();

    root._wiRefreshProductNavigation = () => {
      refreshNavigationTargets();
      requestScrollUpdate();
    };

    root._wiDestroyProduct = () => {
      window.removeEventListener('scroll', requestScrollUpdate);
      window.removeEventListener('resize', requestScrollUpdate);
      variantRequestController?.abort();
      variantRequestController = null;

      if (scrollFrame != null) {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = null;
      }

      root._wiRefreshProductNavigation = null;
      root._wiDestroyProduct = null;
      initialized.delete(root);
    };

};

const initAll = (scope = document) => {
scope.querySelectorAll(SELECTOR).forEach(initProduct); };

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initAll()); } else {
initAll(); }

document.addEventListener('shopify:section:load', (event) => {
initAll(event.target);

    document.querySelectorAll(SELECTOR).forEach((root) => {
      root._wiRefreshProductNavigation?.();
    });

});

document.addEventListener('shopify:section:unload', (event) => {
event.target.querySelectorAll(SELECTOR).forEach((root) => {
root._wiDestroyProduct?.(); });

    requestAnimationFrame(() => {
      document.querySelectorAll(SELECTOR).forEach((root) => {
        root._wiRefreshProductNavigation?.();
      });
    });

}); })();